// extracted by mini-css-extract-plugin
export var chevron = "_ms-2";
export var chevronRotated = "_ms-3";
export var header = "_ms-1";
export var section = "_ms-0";